module.exports = __webpack_public_path__ + "img/blog-shape.a7eca16e.svg";